import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchBuyAgainOdersList } from '../store/thunk/ordersThunk';
import { selectUser } from '../store/reducer/authSlice';

/**
 * Hook to conditionally load buy again orders only when needed
 * Returns buy again orders state and ensures they're loaded for authenticated users
 */
export const useBuyAgainOrders = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const { buyAgainOrders, buyAgainOrdersLoading, buyAgainOrdersError } = useSelector(
    (state) => state.orders
  );

  useEffect(() => {
    // Only load if:
    // 1. User is logged in
    // 2. No orders loaded yet
    // 3. Not currently loading
    // 4. No previous error (to allow retry)
    if (user) {
      //console.log('Loading buy again orders...');
      dispatch(fetchBuyAgainOdersList());
    }
  }, [user]);

  return {
    buyAgainOrders,
    buyAgainOrdersLoading,
    buyAgainOrdersError,
    hasUser: !!user
  };
};

export default useBuyAgainOrders;